module.exports = __webpack_public_path__ + "static/media/50.36bca020.webp";